/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

const uuid = (componentName: string): string => {
  return (
    "md3-" + (componentName || "") + "-" + Math.random().toString(36).slice(4)
  );
};

export { uuid };
